/**
 * @generated SignedSource<<33009b3a1b84bf39ad85f1881d3611e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AtlasProjectGroupHeader$data = {
  readonly project: {
    readonly hasPermission: boolean | null | undefined;
    readonly id: string;
    readonly key: string | null | undefined;
    readonly privateProject: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AtlasProjectGroupHeader";
};
export type AtlasProjectGroupHeader$key = {
  readonly " $data"?: AtlasProjectGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"AtlasProjectGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AtlasProjectGroupHeader",
  "selections": [
    {
      "concreteType": "JiraTownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "privateProject"
        },
        {
          "kind": "ScalarField",
          "name": "hasPermission"
        }
      ]
    }
  ],
  "type": "JiraJqlTownsquareProjectFieldValue"
};

(node as any).hash = "6b7be7742a1e6e71932de9700288d473";

export default node;
